<div class="p-3">
  <div class="d-flex justify-content-between align-items-center">
    <div></div>
    <h4 class="text-center text-grey fw-semibold fs-5 m-0" translate>buy_now</h4>
    <svg-icon src="./assets/images/svg-icons/burger-close.svg" [svgStyle]="{ 'width.px':20, 'height.px':20 }" class="cursor-pointer" (click)="modalRef.hide()"></svg-icon>
  </div>

  <div class="mt-4 content">
    <p translate class="text-center" translate>wert_disclaimer</p>
    <button (click)="showWidget()" class="btn btn-black w-100 font-16" translate>continue</button>
  </div>

</div>
